import { useQuery } from '@apollo/client';

import { CURRENT_USER_REMAINING_SUPER_LIKES } from '../graphql/query/currentUserRemainingSuperLikesQuery.graphql';

export const useCurrentUserRemainingSuperLikesQuery = (eventId: string) => {
  return useQuery(CURRENT_USER_REMAINING_SUPER_LIKES, {
    variables: { eventId },
    fetchPolicy: 'cache-and-network',
  });
};
